import { ObjectGraph } from '@jet/environment/dependencies/object-graph';
import { Bag } from '~/music-classical-client-js/dependencies/bag';
import { ClassicalAPIURLQueryString } from './ClassicalAPIURLQueryString';

export class ClassicalAPIURL {
    path: string;
    domain: string;
    private _queryString?: ClassicalAPIURLQueryString;
    private readonly _objectGraph: ObjectGraph;

    constructor(path: string, objectGraph: ObjectGraph) {
        this.path = path;
        this._objectGraph = objectGraph;
        this.domain = Bag.ampClassicalAPIDomainsDefault(objectGraph);
    }

    get queryString(): ClassicalAPIURLQueryString {
        if (!this._queryString) {
            this._queryString = new ClassicalAPIURLQueryString(
                this._objectGraph,
            );
        }

        return this._queryString;
    }

    get string(): string {
        let url = `${this.domain}${this.path}`;

        const encodedQueryString = this.queryString.encodedString;
        if (encodedQueryString) {
            const hasQueryParams = url.includes('?');
            const conjunction = hasQueryParams ? '&' : '?';
            url += `${conjunction}${encodedQueryString}`;
        }

        return url;
    }
}
